var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0ZM20.0437 9.53128C19.7248 9.21235 19.2209 9.19109 18.8773 9.46749L18.8063 9.53128L11.725 16.6126L9.19372 14.0813C8.85201 13.7396 8.29799 13.7396 7.95628 14.0813C7.63735 14.4002 7.61609 14.9041 7.8925 15.2477L7.95628 15.3187L11.1063 18.4687C11.4252 18.7876 11.9291 18.8089 12.2727 18.5325L12.3437 18.4687L20.0437 10.7687C20.3854 10.427 20.3854 9.87299 20.0437 9.53128Z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.83e67f52b2996d5218700013b383c93b.svg";
export { ForwardRef as ReactComponent };